import { useCallback } from "react";
import { errorHandler, AppError } from "./ErrorHandler";

export const useError = () => {
  const throwError = useCallback((error: Error | AppError) => {
    errorHandler.handleError(error);
  }, []);

  const createError = useCallback(
    (message: string, type: AppError["type"], details?: any) => {
      const error: AppError = {
        name: "AppError",
        message,
        type,
        details,
      };
      return error;
    },
    []
  );

  return { throwError, createError };
};
